import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const ChannelsChart = () => {

    return (
        <Doughnut 
            data={{
            labels: ['Ios', 'Window', 'MacOs', 'Android'],
            datasets: [
                {
                    label: '# of Votes',
                    data: [22, 2, 1, 75],
                    backgroundColor: [
                        '#66CB9F',
                        '#F2994A',
                        '#F2C94C',
                        '#4C6FFF'
                    ],
                    borderColor: [
                        '#66CB9F',
                        '#F2994A',
                        '#F2C94C',
                        '#4C6FFF'
                    ],
                    borderWidth: 1,
                },
            ],
            }}
            height="70%"
            width="100%"
            options={{
                maintainAspectRatio: false,
                responsive: true, 
                cutout: 90,
                plugins: {
                    legend: {
                        align: 'center',
                        position: 'bottom',
                        labels: {
                            boxWidth: 20,
                            boxHeight: 10,
                            color: '#425466'
                        }
                    }
                },
            }}
        />
    )
}
